<template>
  <div :class="['companyBlock__container', {companyBlock__header: this.header}]">
    <div class="ms-pill">
      <q-icon name="fa-solid fa-building" class="ms-pill__icon" />
      <span class="ms-pill__label">{{ this.userData?.company_name || '-' }}</span>
      <q-icon name="fa-solid fa-chevron-down" class="ms-pill__chevron" />
      <q-tooltip anchor="bottom middle" self="top middle" :delay="400">Выберите компанию</q-tooltip>
    </div>
    <q-menu anchor="bottom left" self="top left" :offset="[0, 6]" class="ms-dropdown">
      <q-list style="min-width: 160px">
        <q-item
          v-for="item in this.companies"
          :key="item.company_id"
          clickable
          v-close-popup
          :active="item.company_id === this.userData?.company_id"
          @click="this.handleChangeCompany(item.company_id)"
        >
          <q-item-section>{{item.company_name}}</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>

<script>
import {appActionTypes} from "@/services/store/modules/app_module/app_mutation_types";

export default {
  name: "CompaniesBlock",
  props: {
    header: Boolean
  },
  computed: {
    userData() {
      return this.$store.state.app?.userData
    },
    companies() {
      return this.$store.state.app?.companies
    },
  },
  methods: {
    async handleChangeCompany(company_id) {
      this.$store.dispatch(appActionTypes.chooseCompany, company_id)
    },
  },
}
</script>

<style scoped lang="scss">
// Вид — общая пилюля .ms-pill (assets/styles/theme.scss).
// В хедере блок виден от 577px, на телефоне — в шапке бокового меню.
.companyBlock {
  &__container {
    display: none;
    min-width: 0;
    @media (max-width: 576px) {
      display: flex;
    }
  }

  &__header {
    display: flex;
    @media (max-width: 576px) {
      display: none;
    }
  }
}
</style>
